import Reflux from 'reflux';
import Immutable from 'immutable';

import { StudentLessonProgressActions } from './refluxActions';

// used by TopicGrid only
export const StudentLessonProgressStore = Reflux.createStore({
  listenables: StudentLessonProgressActions,

  init() {
    this.data = {
      isLoadingLessonProgress: false,
      lessonProgress: Immutable.Map(),
    };
  },

  getInitialState() {
    return this.data;
  },

  _setIsLoading(isLoading) {
    this.data.isLoadingLessonProgress = isLoading;
    this.trigger(this.data);
  },

  load() {
    this._setIsLoading(true);
  },

  loadCompleted(response) {
    const newData = response.body;
    this.data.lessonProgress = this.data.lessonProgress.setIn(
      [newData.student_pk, newData.lesson_pk],
      Immutable.fromJS(newData.lesson_progress)
    );
    this.trigger(this.data);
    this._setIsLoading(false);
  },

  loadFailed() {
    this._setIsLoading(false);
  },
});
